<template>
  <div
    :class="getProjectModificator({ row: true })"
    :style="setProjectsCollors(info.color)"
  >
    <div class="col-12" v-if="!isBusy">
      <div class="portlet portlet--projectheader">
        <div class="portlet-body">
          <div class="row">
            <div class="project-title">
              <div class="project-paretname" v-if="info.parent_name">
                <router-link
                  :to="'/construction/' + info.parent_id + '/'"
                  v-if="isNotSubcontractor"
                  >{{ info.parent_name }}</router-link
                >
                <span v-else>{{ info.parent_name }}</span>
              </div>
              <div class="project-name">{{ info.name }}</div>
              <div v-if="isNotSubcontractor && customer">
                {{ customer.companyname }}
                <i style="font-size: 90%"
                  >{{ customer.firstname }} {{ customer.lastname }}</i
                >
              </div>
            </div>
            <div class="project-edit" v-if="isNotSubcontractor">
              <span
                id="button-delete-wrapper"
                class="d-inline-block"
                tabindex="0"
              >
                <b-button
                  variant="outline-danger"
                  class="mr-2"
                  @click="confirmRemove"
                  v-if="hasAccess('constructionsDelete')"
                  :disabled="info.subprojects && info.subprojects.length > 0"
                >
                  <i class="far fa-trash-alt"></i>
                </b-button>
              </span>
              <b-button
                class="btn"
                variant="outline-primary"
                v-b-modal="'info-modal'"
                v-if="hasAccess('constructionsModify')"
              >
                <i class="fas fa-pencil-alt"></i>
              </b-button>
              <b-tooltip
                target="button-delete-wrapper"
                triggers="hover"
                placement="left"
                v-if="info.subprojects && info.subprojects.length > 0"
              >
                Usuń podbudowy by móc usunąć projekt
              </b-tooltip>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-4">
              <div class="project-details" v-if="company">
                <span>Firma:</span>
                {{ company.name }}
              </div>
              <div class="project-details font-italic">
                <span>PUR:</span>
                {{ info.pur }}
              </div>
              <div class="project-details font-weight-bold">
                <span>Adres:</span>
                {{ info.address }}
              </div>
              <div class="project-details">
                <span>Kierownik:</span>
                {{ manager.firstname }} {{ manager.lastname }}
              </div>
              <div class="project-details" v-if="manager.phone">
                <span>Tel. kontaktowy:</span>
                {{ manager.phone }}
              </div>
            </div>
            <div class="project-statusbar col-xl-8">
              <div class="status">
                <span class="status-title">Planowane rozpoczęcie</span>
                <div v-if="info.planned_start_date">
                  <v-date-picker
                    class="datepicker"
                    v-model="dates.planned_start_date"
                    @popoverDidHide="updateDate('planned_start_date')"
                    :popover="{ placement: 'bottom', visibility: 'click' }"
                    v-if="isNotSubcontractor"
                  >
                    <label class="status-label clickable">{{
                      info.planned_start_date | date
                    }}</label>
                  </v-date-picker>
                  <label class="status-label" v-else>{{
                    info.planned_start_date | date
                  }}</label>
                </div>
                <label class="status-label status-label--empty" v-else>-</label>
              </div>
              <div class="status">
                <span class="status-title">Data rozpoczęcia</span>
                <div v-if="info.start_date">
                  <v-date-picker
                    v-model="dates.start_date"
                    @popoverDidHide="updateDate('start_date')"
                    :popover="{ placement: 'bottom', visibility: 'click' }"
                    v-if="isNotSubcontractor"
                  >
                    <label class="status-label clickable">{{
                      info.start_date | date
                    }}</label>
                  </v-date-picker>
                  <label class="status-label" v-else>{{
                    info.start_date | date
                  }}</label>
                </div>
                <label class="status-label status-label--empty" v-else>-</label>
              </div>
              <div class="status">
                <span class="status-title">Data zakończenia</span>
                <div v-if="info.end_date">
                  <v-date-picker
                    v-model="dates.end_date"
                    @popoverDidHide="updateDate('end_date')"
                    :popover="{ placement: 'bottom', visibility: 'click' }"
                    v-if="isNotSubcontractor"
                  >
                    <label class="status-label clickable">{{
                      info.end_date | date
                    }}</label>
                  </v-date-picker>
                  <label class="status-label" v-else>{{
                    info.end_date | date
                  }}</label>
                </div>
                <label class="status-label status-label--empty" v-else>-</label>
              </div>
              <div class="status" v-if="isNotSubcontractor">
                <span class="status-title">Wysłano fakture</span>
                <div v-if="info.end_date">
                  <v-date-picker
                    v-model="dates.planned_end_date"
                    @popoverDidHide="updateDate('planned_end_date')"
                    :popover="{ placement: 'bottom', visibility: 'click' }"
                  >

                    <label class="status-label clickable">{{ info.planned_end_date ? dateValues(info.planned_end_date) : "-" }}</label>


                  </v-date-picker>
                </div>
                <label
                  class="status-label"
                  v-bind:class="[
                    info.planned_end_date ? '' : 'status-label--empty',
                  ]"
                  v-else
                  > {{ info.planned_end_date ? dateValues(info.planned_end_date) : "-" }}</label
                >
              </div>
              <div class="status status--btn">
                <span class="status-title">Status</span>
                <div>
                  <b-dropdown
                    :variant="classStatus(info.status)"
                    :text="statusName(info.status)"
                    toggle-class="btn-wide"
                    no-caret
                    :disabled="!isNotSubcontractor"
                  >
                    <b-dropdown-item-button
                      v-for="(item, index) in optionsStatus"
                      :key="index"
                      :disabled="item.value === info.status"
                      @click="handleChangeStatus(item.value)"
                      >{{ item.text }}</b-dropdown-item-button
                    >
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="portlet-footer">
          <template v-if="hasAccess('constractionBilansView')">
            <div class="project-btninfo">
              <b-button
                variant="link"
                class="btn btn-sm"
                @click="showOffer = !showOffer"
                >
                <i :class="!showOffer? `fas fa-arrow-circle-down fa-2x btn btn-sm` : `fas fa-arrow-circle-up fa-2x btn btn-sm`"></i>
                {{ showOffer ? "Ukryj info" : "Zobacz info" }}
              </b-button
              >

            </div>
            <div
              :class="{
                'text-danger': !parseFloat(info.offer_price),
                'project-img': true,
              }"
              v-b-modal="'price-offer-modal'"
            >
              <i class="fas fa-piggy-bank"></i>
              <div class="font-weight-bold">
                Oferta
                <br />
                <span v-show="showOffer" v-if="info.offer_price"
                  >{{ parseFloat(info.offer_price).toFixed(2) }}
                  {{ getMainBaseCurrency }}</span
                >
              </div>
            </div>
            <div class="project-img">
              <i class="fas fa-cubes"></i>
              <div class="font-weight-bold">
                <a href="#construction_cost">Materiały</a>
                <br />
                <span v-show="showOffer" v-if="costMaterials"
                  >{{ costMaterials.toFixed(2) }}
                  {{ getMainBaseCurrency }}</span
                >
              </div>
            </div>
            <div class="project-img">
              <i class="fas fa-hand-holding-usd"></i>
              <div class="font-weight-bold">
                <a href="#construction_cost">Robocizna</a>
                <br />
                <span v-show="showOffer" v-if="info.cost_subcontractors"
                  >{{ info.cost_subcontractors.toFixed(2) }}
                  {{ getMainBaseCurrency }}</span
                >
              </div>
            </div>
            <div class="project-img">
              <i class="fas fa-chart-pie"></i>
              <div class="font-weight-bold">
                Rentowność
                <br />
                <span v-show="showOffer">
                  <span :class="{ 'text-danger': profitability < 0 }" v-if="profitability"
                    >{{ profitability.toFixed(2) }}
                    {{ getMainBaseCurrency }}</span
                  >
                </span>
              </div>
            </div>
          </template>
          <template v-if="!isMainProject">
            <div
              class="project-img"
              v-if="isNotSubcontractor"
              v-b-modal="'subcontractors-modal'"
            >
              <i class="fas fa-users"></i>
              <div class="font-weight-bold text-left">
                {{ subcontractorsCount }} Podwykonawców <br />Zobacz
              </div>
            </div>

            <div
              class="project-img"
              v-else
              v-b-modal="'subcontractors-view-modal'"
            >
              <i class="fas fa-users"></i>
              <div class="font-weight-bold text-left">
                {{ subcontractorsCount }} Podwykonawców <br />Zobacz
              </div>
            </div>
          </template>
          <div v-else></div>
        </div>
      </div>
      <div class="row">
        <FilesPortlet :construction_id="info.id" />
        <MeasurementCalculations
          :measurement="measurement"
          v-if="!isMainProject"
        />
        <DeadlinesOrdersNotesPortlet
          :construction_id="info.id"
          :notes="notes"
          :supplier_orders="supplier_orders"
        />
      </div>
      <div class="row">
        <div class="col-xl-8">
          <MeasurementPortlet
            :measurement="measurement"
            v-if="!isMainProject"
          />
          <BillsConstructionPortlet
            :construction="info"
            id="construction_cost"
            v-if="isNotSubcontractor"
          />
        </div>
        <div class="col-xl-4">
          <WarehouseConstructionPortlet
            :warehouseEvents="warehouseEvents"
          />
          <ConstructionModalOffer
            :construction_id="info.id"
            :offer_price="info.offer_price"
          />
          <ConstructionModalSubcontractorsForm
            :construction_id="info.id"
            :subcontractors="subcontractors"
          />
          <ConstructionModalSubcontractorsView
            :subcontractors="subcontractors"
          />
        </div>
      </div>
      <div class="row" v-if="info.color && info.parent_id === null">
        <div class="col">
          <ConstructionSubprojectsPortlet
            :parent_id="info.id"
            :subprojects="info.subprojects"
          />
        </div>
      </div>
      <ConstructionModalFormInfo :info="info" :company="company" />
    </div>
    <div class="col-12" v-if="isBusy">
      <TableSpiner />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {formatDateOnly, setProjectsCollors} from "@/services/helpers";
import TableSpiner from "../components/TableSpiner";
import ConstructionModalOffer from "../components/construction/ConstructionModalOffer";
import ConstructionModalFormInfo from "@/components/construction/ConstructionModalFormInfo";
import ConstructionModalSubcontractorsForm from "@/components/construction/ConstructionModalSubcontractorsForm";
import ConstructionModalSubcontractorsView from "@/components/construction/ConstructionModalSubcontractorsView";
import ConstructionSubprojectsPortlet from "@/components/construction/ConstructionSubprojectsPortlet";
import BillsConstructionPortlet from "@/components/bills/BillsConstructionPortlet";
import WarehouseConstructionPortlet from "@/components/warehouse/WarehouseConstructionPortlet";
import MeasurementPortlet from "@/components/measurement/MeasurementPortlet";
import MeasurementCalculations from "@/components/measurement/MeasurementCalculations";
import FilesPortlet from "@/components/files/FilesPortlet";
import DeadlinesOrdersNotesPortlet from "@/components/notes/DeadlinesOrdersNotesPortlet";
import dayjs from "dayjs";

export default {
  name: "TheConstructionDetails",
  components: {
    TableSpiner,
    ConstructionModalOffer,
    ConstructionModalFormInfo,
    ConstructionModalSubcontractorsForm,
    ConstructionModalSubcontractorsView,
    ConstructionSubprojectsPortlet,
    BillsConstructionPortlet,
    WarehouseConstructionPortlet,
    MeasurementPortlet,
    MeasurementCalculations,
    FilesPortlet,
    DeadlinesOrdersNotesPortlet,
  },
  data() {
    return {
      showOffer: false,
      isBusy: true,
      editedDateInput: { type: "", value: null },
      dates: {
        planned_start_date: null,
        planned_end_date: null,
        start_date: null,
        end_date: null,
      },
      notes: [],
      important_events: [],
      supplier_orders: [],
    };
  },
  filters: {
    date(value) {
      return formatDateOnly(value, "YYYY-MM-DD");
    }
  },
  computed: {
    ...mapGetters("user", ["isNotSubcontractor", "hasAccess"]),
    ...mapGetters("construction", [
      "info",
      "customer",
      "manager",
      "subcontractors",
      "subcontractorsCount",
      "measurement",
      "warehouseEvents",
      "calculations",
      "files",
      "company"
    ]),
    ...mapGetters("app", ["optionsStatus", "statusName", "classStatus"]),
    ...mapGetters("company", ["getMainBaseCurrency"]),
    costMaterials() {
      return this.info.cost_materials + this.info.cost_warehouse;
    },
    profitability() {
      return (
        parseFloat(this.info.offer_price) -
        (this.info.cost_materials +
          this.info.cost_subcontractors +
          this.info.cost_warehouse)
      );
    },
    isMainProject() {
      return this.info.parent_id === null && this.info.color !== null;
    },
  },
  mounted() {
    this.getById(this.$route.params.id).then((response) => {
      this.dates.planned_start_date = this.info.planned_start_date
        ? dayjs(this.info.planned_start_date).toDate()
        : null;
      this.dates.start_date = this.info.start_date
        ? dayjs(this.info.start_date).toDate()
        : null;
      this.dates.end_date = this.info.end_date
        ? dayjs(this.info.end_date).toDate()
        : null;
      this.dates.planned_end_date = this.info.planned_end_date
        ? dayjs(this.info.planned_end_date).toDate()
        : null;
      this.notes = response.notes;
      this.supplier_orders = response.orders;
      this.$store.commit("bills/bills", response.bills);
      this.isBusy = false;
    });
    //TODO: catch error;
  },
  methods: {
    ...mapActions("construction", [
      "getById",
      "changeStatus",
      "remove",
      "changeDate",
    ]),
    handleChangeStatus(newStatus) {
      let h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              " Czy napewno chcesz zmienić status budowy na ",
              h("br"),
              h("br"),
              h("h3", this.statusName(newStatus) + "?"),
            ]),
          ],
          {
            title: "Potwierdź zmiane statusu",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
          }
        )
        .then((result) => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          this.changeStatus({
            construction_id: this.info.id,
            newStatus: newStatus,
          });
        });
    },
    updateDate(type) {
      if (dayjs(this.info[type]).isSame(this.dates[type]) === false) {
        this.changeDate({
          construction_id: this.info.id,
          query: {
            type: type,
            date: this.dates[type],
          },
        });
      }
    },
    confirmRemove() {
      this.$bvModal
        .msgBoxConfirm(
          'Czy na pewno chcesz usunąć "' + this.info.name + '" ?',
          {
            title: "Potwierdź usunięcie budowy",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE",
          }
        )
        .then((result) => {
          if (result === true) {
            this.$Progress.start();
            this.remove();
          }
        });
    },
    offerShow() {
      if (this.showOffer === true) {
        this.$nextTick(() => {
          this.$bvModal.show("price-offer-modal");
        });
      }
      this.showOffer = true;
    },
    setProjectsCollors,
    getProjectModificator: function (defaultCSS = {}) {
      if (this.info.parent_id !== null && this.info.color !== null) {
        defaultCSS["project-subproject"] = true;
      }
      if (this.info.parent_id === null && this.info.color !== null) {
        defaultCSS["project-mainproject"] = true;
      }
      return defaultCSS;
    },
    dateValues(value) {
      if (!value) return '-';
      return dayjs(value).format('YYYY-MM-DD');
    },
  },
};
</script>
